import { combineReducers } from '@reduxjs/toolkit';

import rootReducer from './root';
import debuggerReducer from './debugger';
import rolesReducer from './roles';
import modelReducer from './model';
import catalogReducer from './catalog';
import settingsReducer from './settings';
import webformsReducer from './webforms';
import modalsReducer from './modals';
import sharedDatasourcesReducer from './shared-datasources';
import savedConditionsReducer from './shared-conditions';
import explorerReducer from './explorer';
import sharedCss from './shared-css';
import tasksReducer from './tasks';

export const stateReducer = combineReducers({
  root: rootReducer,
  explorer: explorerReducer,
  debugger: debuggerReducer,
  settings: settingsReducer,
  catalog: catalogReducer,
  roles: rolesReducer,
  sharedDatasources: sharedDatasourcesReducer,
  savedConditions: savedConditionsReducer,
  webforms: webformsReducer,
  modals: modalsReducer,
  sharedCSS: sharedCss,
  model: modelReducer,
  tasks: tasksReducer,
});

export { rootReducer };
export type AppState = ReturnType<typeof stateReducer>;

export * from './catalog';
export * from './debugger';
export * from './explorer';
export * from './modals';
export * from './model';
export * from './roles';
export * from './root';
export * from './settings';
export * from './shared-css';
export * from './shared-datasources';
export * from './shared-conditions';
export * from './tabs';
export * from './webforms';
export * from './tasks';
